<template>
  <div class="deep-purple darken-4 fill-absolute">
    <div class="fill-absolute background--container">
      <div class="fill-absolute background--image"></div>
    </div>
    <v-layout row wrap class="fill-absolute gui-flex-rows gui-flex-center-content pa-4">
      <v-flex xs12 sm6 offset-sm3 md4 offset-md4>
        <v-form v-model="valid" ref="form" lazy-validation class="white pa-5 radius-sm elevation-1">
          <v-text-field label="Přihlašovací jméno" v-model="login" :rules="emailRules" required @keydown="keydown" ref="login"></v-text-field>
          <v-text-field label="Heslo" v-model="password" required
          :append-icon="passHidden ? 'visibility' : 'visibility_off'"
          :append-icon-cb="() => (passHidden = !passHidden)"
          :type="passHidden ? 'password' : 'text'"
          @keydown="keydown"
          ></v-text-field>
          <p v-if="errorText.length>0">{{ errorText }}</p>
          <div class="text-center mt10">
            <v-btn @click="submit":disabled="!valid" color="info" :loading="loading" class="white--text elevation-0">
              Přihlásit
            </v-btn>
          </div>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
  export default {
    name: 'SignIn',
    data: () => ({
      valid: true,
      loading: false,
      passHidden: true,
      login: '',
      emailRules: [
        (v) => !!v || 'Přihlašovací jméno je vyžadováno'//,
        //(v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mailová adresa není ve správném formátu'
      ],
      password: '',
      errorText: ''
    }),
    props: {
      source: String
    },
    mounted () {
      this.$nextTick(function() {
        this.$refs.login.$el.focus()
      }.bind(this));
    },
    methods: {
      submit () {
        if (this.$refs.form.validate()) {
          this.$data.errorText = '';
          this.$data.loading = true;
          var x = 0; var y = 0;
          try {
            var win = window,
              doc = document,
              docElem = doc.documentElement,
              body = doc.getElementsByTagName('body')[0];
            x = win.innerWidth || docElem.clientWidth || body.clientWidth;
            y = win.innerHeight|| docElem.clientHeight|| body.clientHeight;
          }
          catch ($e) {

          }
          window.API.post("session/prihlasit", {
              login: this.$data.login,
              heslo: this.$data.password,
              prohlizec: window.MobileDetect.userAgent(),
            zarizeni: window.MobileDetect.tablet() ? 'tablet' : (window.MobileDetect.mobile() ? 'mobil' : 'pc'),
            os: window.MobileDetect.os(),
            rozliseni_sirka: x,
            rozliseni_vyska: y
          }).then(function(body) {
            if (body.prihlasen) {
              //window.API.$setCookie("hn_org", body.UID.toString(), { expires: 30, path: "/" });
              window.API.$setCookie("cc_com_uid", body.uid.toString(), { expires: 30, path: "/" });
              window.API.$setCookie("cc_com_token", body.token, { expires: 30, path: "/" });
              this.$emit("signed");
            }
            else {
              this.$data.errorText = 'Nebyly zadány správné přihlašovací údaje.';
            }
            this.$data.loading = false;
          }.bind(this)).catch(function(err) {
            this.$data.loading = false;
          }.bind(this));
        }
      },
      keydown (e) {
        if (typeof e.keyCode != "undefined" && e.keyCode === 13)
          this.submit();
      }
    }
  }
</script>
<style>
.background--container {

}
.background--image {
  /*background: url('./static/apartment-2094659_1920.jpg');*/
  background-size: cover;
  background-position: center;
}
</style>



// WEBPACK FOOTER //
// src/components/SignIn.vue